import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[cpfEmailMask]',
})
export class CpfEmailMaskDirective {
  constructor(private el: ElementRef<HTMLInputElement>, private r: Renderer2) {}

  @HostListener('input', ['$event'])
  onInput(_: Event) {
    const input = this.el.nativeElement;
    const rawValue = input.value || '';

    // Se contém letras ou símbolos fora dígitos, não mascarar (possível e-mail)
    if (/[^0-9]/.test(rawValue) && /\D/.test(rawValue.replace(/[\.\-]/g, ''))) {
      return;
    }

    // Extrai apenas números
    const digits = rawValue.replace(/\D/g, '');

    // Se tiver menos que 6 dígitos -> só mostra números crus
    if (digits.length < 6) {
      this.r.setProperty(input, 'value', digits);
      return;
    }

    // Limita no máximo a 11 dígitos
    const limited = digits.slice(0, 11);
    const masked = this.applyCpfMask(limited);

    // Atualiza valor e mantém cursor no fim
    const pos = masked.length;
    this.r.setProperty(input, 'value', masked);
    try {
      input.setSelectionRange(pos, pos);
    } catch {}
  }

  private applyCpfMask(digits: string): string {
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return digits.replace(/^(\d{3})(\d+)/, '$1.$2');
    if (digits.length <= 9) return digits.replace(/^(\d{3})(\d{3})(\d+)/, '$1.$2.$3');
    return digits.replace(/^(\d{3})(\d{3})(\d{3})(\d{0,2}).*$/, '$1.$2.$3-$4');
  }
}
